<template>
  <div
    class="flex flex-col items-center justify-center flex-1 bg-brand-light-bg-overlay-50 blur-bg border border-brand-primary h-full overflow-hidden p-4 relative"
  >
    <div
      class="relative max-w-[clamp(0.8rem,min(50cqw,65cqh),16rem)] w-full min-w-20 [@container(max-height:350px){&}]:w-min [@container(max-height:350px){&}]:h-full aspect-square"
    >
      <QuizCorrectAnswerBackground
        class="inset-0 absolute w-full h-full scale-[1.75] -z-10"
      />

      <BigStar class="w-full h-full" />

      <div
        class="inset-0 absolute m-auto z-20 w-full aspect-square scale-[0.575]"
      >
        <Avatar
          :user="user"
          size="responsive"
          :badge="isPaidUser"
          badge-size="xl"
        />
      </div>
    </div>

    <div class="mt-2 text-center font-serif relative z-10">
      <h3
        class="text-[clamp(0.8rem,min(4.66cqw,3cqh),2rem)] leading-normal text-text-primary"
      >
        {{ user.username }}
      </h3>
      <h2
        class="text-[clamp(1.2rem,min(7cqw,5cqh),3rem)] leading-normal text-text-primary"
      >
        {{ $t("channel.show.raffle.winner.isTheWinner") }}
      </h2>
    </div>
  </div>
</template>
<script lang="ts">
import { graphql as gql } from "@/generated";
import type { ResultOf } from "@graphql-typed-document-node/core";

export const RaffleWinnerUserFragment = gql(/* GraphQL */ `
  fragment RaffleWinnerUser on User {
    id
    username
    avatar
    user_channel_memberships {
      channel_membership {
        permission_mask
      }
    }
  }
`);

export type RaffleWinnerUser = ResultOf<typeof RaffleWinnerUserFragment>;
</script>

<script setup lang="ts">
import Avatar from "@/components/me/avatar.vue";
import BigStar from "@/components/ui/contest/big-star.vue";
import QuizCorrectAnswerBackground from "@/components/show/contests/quiz-winner-correct-answer.vue";
import { computed } from "vue";

const props = defineProps<{
  user: RaffleWinnerUser;
}>();

const isPaidUser = computed(() =>
  props.user.user_channel_memberships?.some(
    (cm) => cm.channel_membership?.permission_mask > 0,
  ),
);
</script>
<style scoped>
/* .star-container {
  height: 100cqw;
  width: 100cqw;
}
.avatar1 {
  height: 8cqw;
  width: 8cqw;
}
.avatar {
  height: 30cqw;
  width: 30cqw;
}

@media (orientation: landscape) {
  .star-container {
    height: 100cqh;
    width: 100cqh;
  }

  .avatar {
    height: 30cqh;
    width: 30cqh;
  }
}

.username {
  font-size: clamp(0.8rem, 4.66cqw, 53rem);
  line-height: clamp(0.8rem, 4.66cqw, 53rem);
}

.winner-label {
  font-size: clamp(1.2rem, 7cqw, 80rem);
  line-height: clamp(1.2rem, 7cqw, 80rem);
}

@media (min-width: 375px) and (max-height: 430px) and (orientation: landscape) {
  .username {
    font-size: clamp(0.53rem, 2cqw, 53rem);
    line-height: clamp(0.53rem, 2cqw, 53rem);
  }

  .winner-label {
    font-size: clamp(0.8rem, 3cqw, 80rem);
    line-height: clamp(0.8rem, 3cqw, 80rem);
  }
} */
</style>
